import {
  ActionBtnContainer,
  ActionBtnU,
  ActionContainer,
} from "../../fall-analysis/form/sharedImports";
import { Label, Select, customStyles } from "../../fall-analysis/form/sharedImports";
import {
  DateRangePicker,
  FacilitySelect,
  IncidentTypeSelect,
} from "../../form/incident-inputs";

type CaregiverAuditFormProps = {
  formName: string;
  handleSubmit: () => void;
  facilityOptions: any[];
  setFieldValue: any;
  values: any;
  closeFn: () => void;
  isSubmitDisabled: boolean;
  isFetching: boolean;
  bottom: boolean;
  incidentTypeOptions: any[];
  onIncidentTypeChange: (opt: any) => void;
  caregiverOptions: any[];
  caregiversLoading: boolean;
  onCaregiverChange: (opt: any) => void;
};

// Caregiver Audit param form (MARCC-773). Facility + date range (Fall's pattern)
// plus incident-type and caregiver multiselects, each with a "select all" option.
const CaregiverAuditForm = ({
  formName,
  handleSubmit,
  facilityOptions,
  setFieldValue,
  values,
  closeFn,
  isSubmitDisabled,
  isFetching,
  incidentTypeOptions,
  onIncidentTypeChange,
  caregiverOptions,
  caregiversLoading,
  onCaregiverChange,
}: CaregiverAuditFormProps) => {
  // Facility-change clearing + Modify-mode restore both live in useCaregiverAuditForm —
  // keeping that logic in one place avoids the two racing against each other.
  const checkSubmitDisabled = isSubmitDisabled || !values.facilityInfo;

  return (
    <form name={formName} onSubmit={handleSubmit}>
      <FacilitySelect
        name="facilityInfo"
        placeholder="Select Facility"
        options={facilityOptions}
        isMulti={false}
        onChange={(opt) => setFieldValue("facilityInfo", opt)}
        selected={values.facilityInfo}
      />
      <DateRangePicker
        startDate={values.startDate}
        endDate={values.endDate}
        setFieldValue={setFieldValue}
        limitOneYear={true}
      />
      <IncidentTypeSelect
        name="incidentTypes"
        placeholder="All Incidents"
        options={incidentTypeOptions}
        isMulti={true}
        onChange={onIncidentTypeChange}
        selected={values.incidentTypes}
      />
      <div className="mb-7">
        <Label>Caregiver (searches across all caregiver roles)</Label>
        <Select
          name="caregivers"
          placeholder={
            values.facilityInfo
              ? "All Caregivers"
              : "Select a facility first"
          }
          options={caregiverOptions}
          className="basic-multi-select"
          classNamePrefix="select"
          styles={customStyles}
          isMulti={true}
          isDisabled={!values.facilityInfo}
          isLoading={caregiversLoading}
          onChange={onCaregiverChange}
          value={values.caregivers}
        />
        <p className="mt-1 text-xs italic text-purple-400">
          Searches across: Who Initially Reported Incident, Nurse Assigned,
          CNA Assigned, and Who Last Provided Care.
        </p>
      </div>
      <ActionContainer>
        <ActionBtnContainer
          className="flex w-1/3"
          data-testid="generate-btn-container"
        >
          <ActionBtnU purple_border onClick={() => closeFn()} type="button">
            Cancel
          </ActionBtnU>
          <ActionBtnU
            purpleBg
            white_color
            type="submit"
            onClick={() => handleSubmit()}
            disabled={checkSubmitDisabled}
          >
            {isFetching ? "Loading" : "Generate"}
          </ActionBtnU>
        </ActionBtnContainer>
      </ActionContainer>
    </form>
  );
};

export default CaregiverAuditForm;
